<template>
  <div id="home">
    <el-container>
      <!-- 内容 -->
      <el-main>
        <!-- banner轮播图 -->
        <el-carousel indicator-position="outside" height="300px">
          <el-carousel-item
            class="bannerContent"
            v-for="(item, index) in this.$store.state.bannerData"
            v-bind:key="index"
          >
            <!-- <div :v-bind="item" v-bind:style='{backgroundImage:item }'>
            </div>-->
            <img class="bannerImg" :src="item" />
          </el-carousel-item>
        </el-carousel>

        <!-- 角色展示 -->
        <div class="title">
          <h4>角色展示</h4>
          <el-divider class="line"></el-divider>
        </div>

        <!-- 人物 -->
        <router-link to='/roleDisplay'>
        <div class="role">
          <div class="block" v-for="(item, index) in personList" :key="index">
            <el-image
              style="width: 70%; height: 70%"
              :src="item.rphotograph"
              fit="contain"
            ></el-image>
            <span class="person">{{ item.rname }}</span>
          </div>
        </div>
        </router-link>

        <!-- 文化专区 -->
        <div class="title">
          <h4>文化专区</h4>
          <el-divider class="line"></el-divider>
        </div>

        <!-- 内容 -->
        <router-link to='/cultureZone'>
        <div class="companyProfile">
            <div class="profileText">
              <div class="cultureContent">{{ companyProfileText }}</div>
              <div class="cultureContent">{{ companyProfileText2 }}</div>

              <!-- <h3>{{ footContent }}</h3> -->
            </div>
        </div>
        </router-link>


        <!-- APP资料 -->
        <div class="title">
          <h4>美德少年APP资料</h4>
          <el-divider class="line"></el-divider>
        </div>

        <!-- 内容 -->
        <div class="culture">
            <img
                class="cultureImg"
                src="static/image/appStart.png"
                alt="app"
              />
            <div class="cultureText">
              <div class="cultureContent">{{ cultureMainText }}</div>
              <div class="logoContent">
                <img src="static/image/virtueLogo.png" alt="logo" class="logo">
              <h3 class="cultureTittle">{{ footContent }}</h3>
              </div>
            </div>
        </div>



        <!-- 新闻中心 -->
        <router-link to='/newsCenter'>
        <div class="title">
          <h4>新闻中心</h4>
          <el-divider class="line"></el-divider>
        </div>
        </router-link>

        <!-- 内容 -->
        <div class="newss">
            <div class="newsMainContent">
              <el-tabs v-model="activeName" @tab-click="handleClick">
                <el-tab-pane label="最新" name="first">
                  <div
                    class="news"
                    v-for="(item, index) in this.$store.state.newsList"
                    :key="index"
                  >
                    <div class="newsType">{{ item.newsType }}</div>
                    <div class="newsTittle">{{ item.newsTittle }}</div>
                    <div class="newsDate">{{ item.newsDate }}</div>
                  </div>
                </el-tab-pane>

                <el-tab-pane label="新闻" name="second">
                  <div
                    class="news"
                    v-for="(item, index) in this.$store.state.newsList"
                    :key="index"
                  >
                    <div class="newsType">{{ item.newsType }}</div>
                    <div class="newsTittle">{{ item.newsTittle }}</div>
                    <div class="newsDate">{{ item.newsDate }}</div>
                  </div>
                </el-tab-pane>

                <el-tab-pane label="公告" name="third">
                  <div
                    class="news"
                    v-for="(item, index) in this.$store.state.newsList"
                    :key="index"
                  >
                    <div class="newsType">{{ item.newsType }}</div>
                    <div class="newsTittle">{{ item.newsTittle }}</div>
                    <div class="newsDate">{{ item.newsDate }}</div>
                  </div>
                </el-tab-pane>

                <el-tab-pane label="攻略" name="fourth">
                  <div
                    class="news"
                    v-for="(item, index) in this.$store.state.newsList"
                    :key="index"
                  >
                    <div class="newsType">{{ item.newsType }}</div>
                    <div class="newsTittle">{{ item.newsTittle }}</div>
                    <div class="newsDate">{{ item.newsDate }}</div>
                  </div>
                </el-tab-pane>
              </el-tabs>
            </div>

          <img class="newsImg" src="static/image/banner3.png" alt="app" />
        </div>

        <!-- 玩家互动 -->
        <div class="title">
          <h4>玩家互动</h4>
          <el-divider class="line"></el-divider>
        </div>

        <!-- 内容 -->
        <div class="player">
            <div class="playerContent">
              <el-tabs v-model="activeName" @tab-click="handleClick">
                <el-tab-pane label="最新" name="first">
                  <div
                    class="news"
                    v-for="(item, index) in this.$store.state.newsList"
                    :key="index"
                  >
                    <div class="newsType">{{ item.newsType }}</div>
                    <div class="newsTittle">{{ item.newsTittle }}</div>
                    <div class="newsDate">{{ item.newsDate }}</div>
                  </div>
                </el-tab-pane>

                <el-tab-pane label="论坛" name="second">
                  <div
                    class="news"
                    v-for="(item, index) in this.$store.state.newsList"
                    :key="index"
                  >
                    <div class="newsType">{{ item.newsType }}</div>
                    <div class="newsTittle">{{ item.newsTittle }}</div>
                    <div class="newsDate">{{ item.newsDate }}</div>
                  </div>
                </el-tab-pane>
              </el-tabs>
            </div>

          <img class="playerImg" src="static/image/banner4.png" alt="app" />
        </div>

      </el-main>
    </el-container>
    <!-- 底部 -->
    <div class="pageFoot">
      <div class="footLeft">
         <img
              class="footLogo"
              src="static/image/gongsilogo.png"
              alt="logo"
            />
      </div>
      <div class="footRight">
        <div class="aboutUs">
          <a href="" style=" text-decoration: none;color:#fff">关于我们</a>
          <a href="" style=" text-decoration: none;margin:0 15px;color:#fff"
            >联系我们</a
          >
          <div>Copyright2017</div>
        </div>
        <div>
          深大文德教育科技（深圳）有限公司
          （统一社会信用代码：91440300MA5EE7PL5A）
        </div>
        <div>联系地址：深圳市南山区高新南七道清华大学研究院R2-A</div>

        <div style="margin:0 auto; padding:0px 0; display:flex">
        <p class="beian">粤ICP备20008273号</p>
     <a target="_blank" href=" " style="display:inline-block;text-decoration:none;height:20px;line-height:20px;">
       <div style="display:flex">
         <img src="../../static/image/recordsIMG.png" style="float:left;"/>
       <p p class="beian" >粤公网安备 44030502007871号</p >
       </div>
       </a>
    </div>
      </div>


    
    </div>
 
    

    <router-view />
  </div>
</template>

<script>
import apiURL from "../api/apiURL";
export default {
  name: "home",
  data() {
    return {
      activeIndex: "1",
      activeIndex2: "1",
      image: "",
      personList: [],
      bannerDataobj: [
        {
          src: "static/image/banner1.jpg",
          studentData: [
            {
              pos: {},
              logo: "static/image/banner1.jpg",
              value: "小明同学"
            },
            {
              logo: "static/image/banner1.jpg",
              value: "小红同学"
            }
          ]
        }
      ],
      banner: "static/image/banner1.png",

      companyProfileText:"深大文德教育科技（深圳）有限公司（统一社会信用代码：91440300MA5EE7PL5A，注册地：深圳市前海深港合作区前湾一路1号A栋201室，以下简称“深大文德”）成立于2017年，是一家依托深圳大学为资源平台、面向社会发展的现代化教育研发机构，公司主营业务为教育软件开发和青少年素质培训。",
      companyProfileText2:'教育理念：吸取并结合中西教育理念优点，总结出一套全新的“中学养德，西学养功”的教学方针。教学内容上以素质优先、习惯养成为出发点，逐步实现单科突破，全面发展。在授课对象上坚持有教无类、因材施教的操作思路，培育学习素质，锻造少年英才。教育对象：从幼儿园到中学生（3岁到18岁），其中重点在5-9岁阶段。教育目标：培养高素质的青少年是我们教育的根本目标。具体分四个方面：孝敬父母、和谐共处、夯实基础、做事靠谱。',

      cultureMainText:"美德少年，是一款寓教于乐的情景再现德育系统，以中学养德、西学养功为原则。内容上实现中华传统美德与世界优秀品德的有机结合，并实现科学理性与社会主义核心价值观的有机结合。通过情景再现模拟技术与设计，让每一个小孩子都在情景中切身体会美德与理性之光，同时在线下与父母形成良性的亲自关系，与朋友同学形成和谐的互助关系。久而久之，习惯成自然，知识转实惠。",
      footContent: "美德少年，热爱集体，孝敬父母，与人为善，和谐共处",
      activeName: "first",

      info:
        "深大文德教育科技（深圳）有限公司 （统一社会信用代码：91440300MA5EE7PL5A）",
      address: "联系地址：深圳市南山区高新南七道清华大学研究院R2-A"
    };
  },

  created() {
    this.rolesData();
  },

  methods: {
    //角色展示
    rolesData() {
      let self = this;
      // 发送 POST 请求
      this.$axios
        .post("http://8.129.62.150:8080/index/roles", {
          current: "1",
          size: "4"
        })
        .then(function(res) {
          console.log(res)
          self.personList = res.data.data.list;
        });
    },

    handleClick(tab, event) {
      console.log(tab, event);
    }
  }
};
</script>

<style scoped>
body {
  background: #fbfff5;
}
#home {
  font-family: "Avenir", Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  color: #2c3e50;
}

.el-footer {
  width: 100%;
  height: 50%;
  background-color: blueviolet;
  font-size: 10px;
  line-height: 28px;
  text-align: center;
}
body > .el-container {
  margin-bottom: 40px;
}
/* .el-container {
  margin: 0 22%;

} */

.el-carousel__item h3 {
  color: #475669;
  font-size: 18px;
  opacity: 0.75;
  line-height: 300px;
  margin: 0;
  background: #fbfff5;
}

.el-carousel__item:nth-child(2n) {
  background-image: url("");
  background: #fbfff5;
}

.el-carousel__item:nth-child(2n + 1) {
  background: #fbfff5;

}

.bannerContent {
  height: 150%;
}

.bannerImg {
  height: auto;
  width: 100%;
}

.title {
  background: #edf9dc;
  height: 100px;
  color: #89c33f;
  padding-top: 60px;
  font-size: 16px;

}
.line {
  background: #c8e595;
}
.role {
  margin: 10% 0;
  display: flex;
  border: 2px solid #89c33f;
  color: #603813;
  font-size: 16px;
  font-weight: bold;
}
.person {
  font-size: 16px;
}
.companyProfile {
  font-size: 14px;
  color: #603813;
  border: 2px solid #89c33f;
  margin: 5% 0;
  padding: 2% ;
}
.cultureTittle {
  font-size: 14px;

}
.culture {
  display: flex;
  flex-wrap: wrap;
  /* float: left; */
  color: #603813;
  border: 2px solid #89c33f;
  margin: 5% 0;
  padding: 2% ;

}
.cultureText {
  width: 48%;
  padding: 1%;
}
.cultureImg {
  height: 50%;
  width: 50%;
  /* margin:1%; */
}
.cultureContent {
  line-height: 180%;
  text-align: left;
  font-size: 14px;

}
.block {
  display: flex;
  flex-direction: column;
  align-items: center;
}

.el-row {
  margin: 20px 0;
  /* &:last-child {
      margin-bottom: 0;
    } */
}
.el-col {
  border-radius: 4px;
  color: #603813;
}
.newss {
  display: flex;
  border: 2px solid #89c33f;
  font-size: 14px;
  margin: 5% 0;
  padding: 1%;
}
.news {
  font-size: 14px;
  display: flex;
  justify-content: space-between;

}
.newsImg {
  height: 50%;
  width: 50%;
}
.newsMainContent {
  width: 50%;
  padding: 1%;

}
.playerImg {
  height: 50%;
  width: 50%;
}
.player {
  display: flex;
  border: 2px solid #89c33f;
  font-size: 14px;
  margin: 5% 0;
  padding: 1%;
}
.playerContent {
  width: 50%;
  padding: 1%;

}

.footLogo {
  width: 60%;
  height: 60%;
}
.footText1 {
  display: flex;
}
.textContent {
  line-height: 37px;
  text-align: left;
  color: #fff;
}
.footImg {
  z-index: -100;
}
.row-bg {
  position: relative;
  bottom: -160px;
  color: #fff;
}


.pageFoot {
  width: 100%;
  height: 20%;
  color: #ffffff;
  display: flex;
  /* flex-direction: column; */
  align-items: center;
  background-color: #89C33F;
  padding: 5px 0;
  /* padding: 5% 0; */
}
.footLeft {
  width: 20%;
  height: 20%;
}
.footRight {
  display: flex;
  flex-direction: column;
  align-items: center;
  font-size: 10px;
}
.aboutUs {
  display: flex;
}

a{
    text-decoration: none;
}
.router-link-active {
    text-decoration: none;
}
.logo {
  width: 10%;
  margin-right: 1%;
}
.logoContent {
  display: flex;
  align-items: center;
}

@media screen and (max-width: 700px) {
  /* 文化专区 */
  .culture {
  flex-direction: column;
}
.cultureText {
  width: 100%;
}
.cultureImg {
  height: 100%;
  width: 100%;
}
/* 新闻中心 */
.newsImg {
  height: 100%;
  width: 100%;
}
.newsMainContent {
  width: 100%;
}
.newss {
  flex-direction: column;
}

.player {
flex-direction: column;
}
.playerImg {
  height: 100%;
  width: 100%;
}
.playerContent {
  width: 100%;
}

.el-carousel__container {
    height: 200px;
}
.bannerContent {
  height: 60%;
}
}
.beian {
  float:left;
  height:20px;
  line-height:20px;
  margin: 0px 0px 0px 5px; 
  color:#ffffff;
  font-size:10px
}
</style>



// WEBPACK FOOTER //
// src/components/homPage.vue